module.exports = __webpack_public_path__ + "static/media/NICE_Step2a_Image22.17e8dc0d.jpg";